import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const LocationsQuickView = () => {
  const locations = [
    {
      id: 1,
      name: "Koramangala",
      address: "123 Street Food Lane, Koramangala 4th Block, Bengaluru - 560034",
      phone: "+91 98765 43210",
      hours: "11:00 AM - 11:00 PM",
      status: "Open Now",
      isOpen: true,
      features: ["Dine-in", "Takeaway", "Outdoor Seating"],
      distance: "2.5 km away"
    },
    {
      id: 2,
      name: "Indiranagar",
      address: "456 Flavor Street, 100 Feet Road, Indiranagar, Bengaluru - 560038",
      phone: "+91 98765 43211",
      hours: "11:00 AM - 11:00 PM",
      status: "Open Now",
      isOpen: true,
      features: ["Dine-in", "Takeaway", "Parking"],
      distance: "4.8 km away"
    },
    {
      id: 3,
      name: "Whitefield",
      address: "789 Tech Park Road, ITPL Main Road, Whitefield, Bengaluru - 560066",
      phone: "+91 98765 43212",
      hours: "11:00 AM - 11:00 PM",
      status: "Open Now",
      isOpen: true,
      features: ["Dine-in", "Takeaway", "Quick Service"],
      distance: "8.2 km away"
    }
  ];

  return (
    <section className="py-16 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-foreground mb-4">
            Find Us Across Bengaluru
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Visit any of our locations for an authentic Mexican street food experience
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {locations?.map((location) => (
            <div
              key={location?.id}
              className="bg-card rounded-xl p-6 hover:shadow-xl transition-all duration-300 border border-border animate-slide-up"
            >
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h3 className="text-2xl font-bold text-foreground mb-1">
                    {location?.name}
                  </h3>
                  <div className="flex items-center gap-2">
                    <span className={`w-2 h-2 rounded-full ${location?.isOpen ? 'bg-trust-green' : 'bg-error'}`} />
                    <span className={`text-sm font-medium ${location?.isOpen ? 'text-trust-green' : 'text-error'}`}>
                      {location?.status}
                    </span>
                  </div>
                </div>
                <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                  <Icon name="MapPin" size={24} color="var(--color-primary)" />
                </div>
              </div>

              <div className="space-y-3 mb-6">
                <div className="flex items-start gap-3">
                  <Icon name="MapPin" size={18} color="var(--color-muted-foreground)" className="flex-shrink-0 mt-1" />
                  <p className="text-sm text-muted-foreground">
                    {location?.address}
                  </p>
                </div>

                <div className="flex items-center gap-3">
                  <Icon name="Phone" size={18} color="var(--color-muted-foreground)" />
                  <p className="text-sm text-muted-foreground">
                    {location?.phone}
                  </p>
                </div>

                <div className="flex items-center gap-3">
                  <Icon name="Clock" size={18} color="var(--color-muted-foreground)" />
                  <p className="text-sm text-muted-foreground">
                    {location?.hours}
                  </p>
                </div>

                <div className="flex items-center gap-3">
                  <Icon name="Navigation" size={18} color="var(--color-muted-foreground)" />
                  <p className="text-sm text-primary font-medium">
                    {location?.distance}
                  </p>
                </div>
              </div>

              <div className="flex flex-wrap gap-2 mb-6">
                {location?.features?.map((feature, index) => (
                  <span
                    key={index}
                    className="px-3 py-1 bg-muted text-muted-foreground text-xs font-medium rounded-full"
                  >
                    {feature}
                  </span>
                ))}
              </div>

              <div className="flex gap-3">
                <Button
                  variant="default"
                  size="default"
                  iconName="Navigation"
                  iconPosition="left"
                  fullWidth
                >
                  Get Directions
                </Button>
                <Button
                  variant="outline"
                  size="default"
                  iconName="Phone"
                  iconPosition="left"
                >
                  Call
                </Button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Button
            variant="outline"
            size="lg"
            iconName="MapPin"
            iconPosition="left"
          >
            View All Locations
          </Button>
        </div>
      </div>
    </section>
  );
};

export default LocationsQuickView;